import { atom } from "recoil";

export const ItemNameState = atom({
    key: 'ItemName',
    default:'',
});

export const ItemPriceState = atom({
    key: 'ItemPrice',
    default:'',
});



export const OptionsState = atom({
    key: 'SelectValues',
    default:[
        { value: "online", label: "온라인" },
        // { value: "offlone", label: "오프라인" }
       ],
});

export const  PostObjectState = atom({
    key: 'PostObjects',
    default:{},
});

